 <template>
  <div>
    <activity-redirect-item
        :loan-tasks="tasks"
        :current-loan-task="currentTaskName"
        :is-loan-task="true"
        :redirect-activity="redirectActivity"
    ></activity-redirect-item>

    <address-stage-provider
    :propShowSameAsCurrentAddressCheckbox="false"
    :addressType="addressType"
    :tasks="tasks"
    :currentTaskName="currentTaskName"
    ></address-stage-provider>
  </div>
</template>

<script>

import LoanScopeDataHolder from "@/data/model/LoanScopeDataHolder";

import ActivityRedirectItem from "../layout/ActivityRedirectItem";
import {Activities} from "@/utils/ActivityNavigator";
import AddressStageProvider
  from "@/components/providers/AddressStageProvider";
import AddressResponse from '../../data/model/AddressResponse';

export default {
  name: "AddressActivity",
  components: {ActivityRedirectItem, AddressStageProvider},

  computed: {
    redirectActivity() {
      return Activities.LOAN_DETAILS;
    },

    tasks() {
      return [Activities.ADDRESS];
    },

    currentTaskName() {
      return LoanScopeDataHolder.getCurrentLoanTask()
          ? LoanScopeDataHolder.getCurrentLoanTask().name : "";
    },

    addressType() {
      return AddressResponse.HOME_ADDRESS_TYPE;
    }
  }
}
</script>

<style scoped></style>

 
 
 <!-- <template>
  <div>
    <tool-bar :title="toolbarTitle"></tool-bar>
    <loading :loading="loading"></loading>

    <error-alert-item
      :error-alert-event="errorAlertEvent"
      :network-error="networkError"
      @resetErrorAlertEvent="errorAlertEvent=false">
    </error-alert-item>

    <activity-redirect-item
      :loan-tasks="tasks"
      :current-loan-task="currentTaskName"
      :is-loan-task="true"
      :redirect-activity="redirectActivity"
    ></activity-redirect-item>

    <stage-comment-item></stage-comment-item>

    <refresh-item
      :show="showRefreshItem"
      @onRefresh="fetchInitialData"
    ></refresh-item>

    <div class="margin_top_20" v-if="showUI">
      <div class="item-heading-desc-div margin-left-10 margin-right-10">
        <weex-text class="item-heading">{{addressHeading}}</weex-text>
        <!-- <weex-text class="item-base-description margin-top-10 text-color-gray" 
          v-if="addressProofWillRequiredLater">
          {{addressDescription}}
        </weex-text> 
      </div>

      <kyc-address-proof-document
        v-if="addressProofWillRequiredLater"
        :kyc-osv-details-config="kycOsvDetailsConfig"
        @addressProofAttached="addressProofAttached=true"
        @kycAddressProofDocumentUploadCompeleted="saveAddress"
        ref="kycAddressProofDocumentItem"
      ></kyc-address-proof-document>

      <div class="input_container">
        <weex-text class="input_label">Flat/HouseNo./Floor/Building</weex-text>
        <input
          class="input_with_border_bottom"
          :value="getFieldValue('street')"
          @input="inputEntered('street', $event.target.value)"
          return-key-type="next">
      </div>

      <div class="input_container">
        <weex-text class="input_label">Colony/Street/Locality</weex-text>
        <input
          class="input_with_border_bottom"
          :value="getFieldValue('addressLine1')"
          @input="inputEntered('addressLine1', $event.target.value)"
          return-key-type="next">
      </div>

      <div class="input_container">
        <weex-text class="input_label">Landmark</weex-text>
        <weex-text class="input_label_des">(Optional)</weex-text>
        <input
          class="input_with_border_bottom"
          :value="getFieldValue('addressLine2')"
          @input="inputEntered('addressLine2', $event.target.value)"
          return-key-type="next">
      </div>

      <div class="input_container">
        <weex-text class="input_label">Pin Code</weex-text>
        <input
          class="input_with_border_bottom"
          :value="getFieldValue('postalCode')"
          @input="postalEntered($event.target.value)"
          type="number"
          maxlength="6"
          return-key-type="next">
      </div>

      <div class="dropdown_container">
        <wxc-dropdown
          title="State"
          default-item="Select State"
          :config="dropdownConfig"
          :disabled="stateDropdownDisabled"
          :select-item="selectState"
          :list="stateList"
          @onItemSelected="onStateSelected"
        ></wxc-dropdown>
      </div>

      <div class="input_container">
        <weex-text class="input_label">District</weex-text>
        <input
          :readonly="disableAddressLine3"
          class="input_with_border_bottom"
          :value="getFieldValue('addressLine3')"
          @input="inputEntered('addressLine3', $event.target.value)"
          return-key-type="next">
      </div>

      <div class="input_container">
        <weex-text class="input_label">City</weex-text>
        <input
          :readonly="disableCity"
          class="input_with_border_bottom"
          :value="getFieldValue('city')"
          @input="inputEntered('city', $event.target.value)"
          return-key-type="done">
      </div>

      <div class="input_container" v-if="isFieldNeeded('current_address_rent')">
        <weex-text class="input_label">{{getFieldLabel('current_address_rent')}}</weex-text>
        <div class="item-price-input-container">
          <input
            :readonly="true"
            class="item-price-label-input"
            :value="rupeeSign" />
          <input
            class="item-price-input"
            :value="getDynamicFieldValue('current_address_rent')"
            @input="onDynamicFieldEntered('current_address_rent', $event.target.value)"
            type="number" />
        </div>
        <field-error-item
          :show-error="showFieldError('current_address_rent')"
          :error-msg="getErrorMsg('current_address_rent')"
        ></field-error-item>
      </div>

      <div class="item-row-alignment margin_top_20">
        <div
          style="width: 50%; margin: 0 5px 0 10px"
          v-if="isFieldNeeded('current_address_years')">
          <weex-text class="input_label">{{getFieldLabel('current_address_years')}}</weex-text>
          <input
            class="input_with_border_bottom"
            :value="getDynamicFieldValue('current_address_years')"
            @input="onDynamicFieldEntered('current_address_years', $event.target.value)"
            return-key-type="next">
          <field-error-item
            :show-error="showFieldError('current_address_years')"
            :error-msg="getErrorMsg('current_address_years')"
          ></field-error-item>
        </div>

        <div style="width: 50%; margin: 0 10px 0 5px"
             v-if="isFieldNeeded('current_address_months')">
          <weex-text class="input_label">{{getFieldLabel('current_address_months')}}</weex-text>
          <input
            class="input_with_border_bottom"
            :value="getDynamicFieldValue('current_address_months')"
            @input="onDynamicFieldEntered('current_address_months', $event.target.value)"
            return-key-type="next">
          <field-error-item
            :show-error="showFieldError('current_address_months')"
            :error-msg="getErrorMsg('current_address_months')"
          ></field-error-item>
        </div>
      </div>

      <div class="dropdown_container" v-if="isFieldNeeded('address_ownership_type')">
        <wxc-dropdown
          default-item="Select"
          :title="getFieldLabel('address_ownership_type')"
          :select-item="selectOwnership"
          :config="dropdownConfig"
          :list="addressOwnershipList"
          @onItemSelected="onOwnershipSelected"
        ></wxc-dropdown>
      </div>

      <div class="item-row-alignment margin_top_20">
        <div
          style="width: 50%; margin: 0 5px 0 10px"
          v-if="isFieldNeeded('current_city_years')">
          <weex-text class="input_label">{{getFieldLabel('current_city_years')}}</weex-text>
          <input
            class="input_with_border_bottom"
            :value="getDynamicFieldValue('current_city_years')"
            @input="onDynamicFieldEntered('current_city_years', $event.target.value)"
            return-key-type="next">
          <field-error-item
            :show-error="showFieldError('current_city_years')"
            :error-msg="getErrorMsg('current_city_years')"
          ></field-error-item>
        </div>

        <div style="width: 50%; margin: 0 10px 0 5px"
             v-if="isFieldNeeded('current_city_months')">
          <weex-text class="input_label">{{getFieldLabel('current_city_months')}}</weex-text>
          <input
            class="input_with_border_bottom"
            :value="getDynamicFieldValue('current_city_months')"
            @input="onDynamicFieldEntered('current_city_months', $event.target.value)"
            return-key-type="next">
          <field-error-item
            :show-error="showFieldError('current_city_months')"
            :error-msg="getErrorMsg('current_city_months')"
          ></field-error-item>
        </div>
      </div>

      <wxc-button
        style="margin-top: 40px; margin-bottom: 20px"
        text="Next"
        class="button_horizontal_center"
        type="blue"
        @wxcButtonClicked="onSubmit"
      ></wxc-button>
    </div>
  </div>
</template>

<script>
import ToolBar from "../layout/ToolBar";
import Loading from "../layout/Loading";
import ActivityRedirectItem from "../layout/ActivityRedirectItem";
import StageCommentItem from "../layout/StageCommentItem";
import ErrorAlertItem from "../layout/ErrorAlertItem";
import WxcButton from "../../../weex-ui/packages/wxc-button";
import WxcDropdown from "../../../weex-ui/packages/wxc-dropdown";
import EzUtils from "../../utils/EzUtils";
import LoanTasksActivityNavigator from "../../utils/LoanTasksActivityNavigator";
import DataTableUtils from "../../utils/DataTableUtils";
import { DefaultResourceConfig } from "../../utils/ImageResourcesUtil";
import { MessageConstants } from "../../utils/MessageConstantUtil";
import { Activities } from "../../utils/ActivityNavigator";
import LoanTasksUtility from "../../utils/LoanTasksUtility";
import LoanScopeDataHolder from "../../data/model/LoanScopeDataHolder";
import DataSource from "../../data/DataSource";
import AddressResponse from "../../data/model/AddressResponse";
import AlertService from "../core/alert/AlertService";
import PrefManager from "../../data/model/PrefManager";
import { RolesConstants } from "../../utils/RolesConstants";
import RefreshItem from "../layout/RefreshItem";
import FieldErrorItem from "../layout/FieldErrorItem";
import DynamicFieldUtils, { FieldTypes } from "../../utils/DynamicFieldUtils";
import { DataTables } from "../../utils/DataTables";
import storageUtil from "../../utils/StorageUtil";
import KycAddressProofDocument from "../layout/KycAddressProofDocument";

const DEFAULT_ADDRESS_LIST = ["AADHAAR", "VOTER_ID", "ELECTRICITY_BILL"];

const REGEX_YEARS = "^[0-9]{1,2}$";
const REGEX_MONTH = "^(0|0?[1-9]|1[01])$";
const REGEX_AMOUNT = "(^[0-9]+[.]*[0-9]+$|^[0-9]+$)";
const RUPEE = "\u20B9";
const ALL_FIELDS_DATA = {
  current_address_rent: {
    label: "Monthly Rent",
    validation: REGEX_AMOUNT,
    fieldType: "EDIT_FIELD",
    errorMsg: "Enter valid amount.",
    optional: false
  },

  current_address_years: {
    label: "Years at Address",
    validation: REGEX_YEARS,
    fieldType: "EDIT_FIELD",
    errorMsg: "Enter valid no of Years.",
    optional: false
  },

  current_address_months: {
    label: "Months at Address",
    validation: REGEX_MONTH,
    fieldType: "EDIT_FIELD",
    errorMsg: "Allowed value: 0-11",
    optional: false
  },

  current_city_years: {
    label: "Years at City",
    validation: REGEX_YEARS,
    fieldType: "EDIT_FIELD",
    errorMsg: "Enter valid no of Years.",
    optional: false
  },

  current_city_months: {
    label: "Months at City",
    validation: REGEX_MONTH,
    fieldType: "EDIT_FIELD",
    errorMsg: "Allowed value: 0-11",
    optional: false
  },

  address_ownership_type: {
    key: "address_ownership_type",
    label: "Address Ownership Type",
    validation: "",
    fieldType: FieldTypes.DROPDOWN,
    errorMsg: "Please select Address Ownership Type.",
    optional: true
  },
};

export default {
  name: "AddressActivity",
  components: {
    ActivityRedirectItem,
    ErrorAlertItem,
    Loading,
    ToolBar,
    WxcButton,
    WxcDropdown,
    StageCommentItem,
    RefreshItem,
    FieldErrorItem,
    KycAddressProofDocument,
  },
  data: () => ({
    toolbarTitle: "Address",
    address: {
      street: "",
      addressLine1: "",
      addressLine2: "",
      addressLine3: "",
      city: "",
      postalCode: "",
      stateProvinceId: -1,
      addressTypeId: -1,
      countryId: -1,
      addressOwnershipTypeId: null,
      monthsAtAddress: null,
      yearsAtAddress: null,
    },
    addressTimeData: {
      current_address_years: null,
      current_address_months: null,
      current_city_years: null,
      current_city_months: null,
      current_address_rent: null
    },
    showUI: false,
    stateList: [],
    selectState: null,
    disableCity: false,
    disableAddressLine3: false,
    stateDropdownDisabled: false,
    stateProvinceIdOptions: [],
    allowedAddressProofsList: [],
    loading: false,
    errorAlertEvent: false,
    networkError: {},
    showRefreshItem: false,
    addressTypeId: -1,
    countryId: -1,
    dynamicFields: null,
    invalidFields: [],
    addressProofWillRequiredLater: true,
    kycStageDataConfig: {},
    kycAddressProofDocumentUploadCompeleted: false,
    addressProofAttached: false,
    addressOwnershipList: [],
    addressOwnerTypeIdOptions: [],
    selectOwnership : null,
  }),
  methods: {
    isFieldNeeded(key) {
      return this.dynamicFields == null || this.dynamicFields[key] != null;
    },

    getFieldLabel(key) {
      return this.dynamicFields && this.dynamicFields[key] && this.dynamicFields[key]['label']
        ? this.dynamicFields[key]["label"]
        : ALL_FIELDS_DATA[key]["label"];
    },

    getFieldValue(key) {
      return this.address && this.address[key] ? this.address[key] : "";
    },

    onDynamicFieldEntered(key, value) {
      this.addressTimeData[key] = value;
      this.addressTimeDataAndAddressObjectMapping(key, value);
      this.removeFromInvalidFieldsIfValid(key);
    },

    addressTimeDataAndAddressObjectMapping(key, value){
      let addressTimeAndAddressMap = {
        current_address_years : "yearsAtAddress",
        current_address_months : "monthsAtAddress"
      }
      if(addressTimeAndAddressMap[key]){
        this.inputEntered(addressTimeAndAddressMap[key],value)
      }
    },

    removeFromInvalidFieldsIfValid(key) {
      this.invalidFields = DynamicFieldUtils.removeFromInvalidFieldsIfValidValue(
        this.invalidFields,
        key,
        this.addressTimeData[key],
        ALL_FIELDS_DATA,
        this.dynamicFields
      );
    },

    getDynamicFieldValue(key) {
      return this.addressTimeData && this.addressTimeData[key] ? this.addressTimeData[key] : "";
    },

    showFieldError(key) {
      return this.invalidFields && this.invalidFields.includes(key);
    },

    getErrorMsg(key) {
      return ALL_FIELDS_DATA[key]["errorMsg"];
    },

    inputEntered(key, value) {
      this.address[key] = value;
    },

    onStateSelected(e) {
      this.onStateEntered(e.value);
    },

    onOwnershipSelected(e) {
      this.onOwnershipEntered(e.value);
    },

    onStateEntered(state) {
      this.selectState = state;
      this.inputEntered(AddressResponse.STATE_PROVINCE_ID,
        parseInt(DataTableUtils.getOptionId(this.stateProvinceIdOptions, state))
      );
    },

    onOwnershipEntered(ownership) {
      this.selectOwnership = ownership
      this.inputEntered(AddressResponse.ADDRESS_OWNERSHIP_TYPE,
        parseInt(DataTableUtils.getOptionId(this.addressOwnerTypeIdOptions, ownership))
      );
    },


    postalEntered(postalCode) {
      this.inputEntered(AddressResponse.POSTAL_CODE, postalCode);
      this.getPostalCodeDetails();
    },

    getPostalCodeDetails() {
      if (EzUtils.validatePostalCode(this.getFieldValue(AddressResponse.POSTAL_CODE))) {
        this.loading = true;
        DataSource.getPincodeDetails(this.getFieldValue(AddressResponse.POSTAL_CODE))
          .then(postalCodeRes => {
            this.loading = false;
            if (postalCodeRes.errorOccurred) {
              this.selectState = "";
              this.stateDropdownDisabled = false;
              this.disableCity = false;
              this.disableAddressLine3 = false;
            } else {
              const postalCodeData = postalCodeRes.data ? postalCodeRes.data : {};
              if (this.isValidState(postalCodeData.state)) {
                this.selectState = postalCodeData.state;
                this.stateDropdownDisabled = true;
              } else {
                this.stateDropdownDisabled = false;
                this.selectState = "";
              }
              if (postalCodeData.district) {
                this.inputEntered(AddressResponse.ADDRESS_LINE3, postalCodeData.district);
                this.inputEntered(AddressResponse.CITY, postalCodeData.district);
                this.disableCity = true;
                this.disableAddressLine3 = true;
              } else {
                this.disableCity = false;
                this.disableAddressLine3 = false;
              }
            }
          });
      } else {
        this.selectState = "";
        this.stateDropdownDisabled = false;
        this.disableCity = false;
        this.disableAddressLine3 = false;
      }
    },

    isValidState(state) {
      let validState = false;
      this.stateList && this.stateList.forEach(item => {
        if (item && item === state) {
          validState = true;
        }
      });

      return validState;
    },

    onSubmit() {
      if (this.checkForValidation()) {
        if(this.addressProofWillRequiredLater){
          this.$refs.kycAddressProofDocumentItem.onContinueClicked();
        }else{
          this.saveAddress();
        }
      }
    },

    checkForValidation() {
      this.invalidFields = DynamicFieldUtils.validateDynamicFieldsForRequiredFields(
        this.addressTimeData,
        ALL_FIELDS_DATA,
        this.dynamicFields
      );
      if (!this.getFieldValue(AddressResponse.STREET)
        || !this.getFieldValue(AddressResponse.ADDRESS_LINE1)
        || !this.getFieldValue(AddressResponse.ADDRESS_LINE3)
        || !this.getFieldValue(AddressResponse.CITY)
        || !this.getFieldValue(AddressResponse.POSTAL_CODE)
      ) {
        this.showToast(MessageConstants.EMPTY_FIELD_MESSAGE);
        return false;
      }

      if (!this.isValidStreetAddress()) {
        this.showToast(MessageConstants.INVALID_STREET_ADDRESS_MESSAGE);
        return false;
      }

      if (!EzUtils.validatePostalCode(this.getFieldValue(AddressResponse.POSTAL_CODE))) {
        this.showToast(MessageConstants.INVALID_POSTAL_CODE_MESSAGE);
        return false;
      }

      if (!this.getFieldValue(AddressResponse.STATE_PROVINCE_ID)
        || parseInt(this.getFieldValue(AddressResponse.STATE_PROVINCE_ID)) === -1
      ) {
        this.showToast(MessageConstants.SELECT_STATE_MESSAGE);
        return false;
      }

      if (this.isFieldNeeded(ALL_FIELDS_DATA.address_ownership_type.key) &&
        (!this.getFieldValue(AddressResponse.ADDRESS_OWNERSHIP_TYPE) 
        || parseInt(this.getFieldValue(AddressResponse.ADDRESS_OWNERSHIP_TYPE)) === -1)
      ) {
        this.showToast(MessageConstants.SELECT_ADDRESS_OWNERSHIP_TYPE_MESSAGE);
        return false;
      }

      if(this.addressProofWillRequiredLater && !this.addressProofAttached){
        this.showToast(MessageConstants.UPLOAD_ADDRESS_PROOF_MESSAGE);
        return false;
      }

      return !this.invalidFields || this.invalidFields.length === 0;
    },

    isValidStreetAddress() {
      let streetArray = this.getFieldValue(AddressResponse.STREET).trim().split(" ");
      if (streetArray.length < 2) {
        return false;
      }
      let streetItemCount = 0;
      streetArray.forEach(streetSplitValue => {
        streetItemCount = (streetSplitValue.trim().length > 1) ? streetItemCount + 1
          : streetItemCount;
      });
      return (streetItemCount > 0);
    },

    showToast(message) {
      AlertService.showToast(message);
    },

    showError(error) {
      this.loading = false;
      this.networkError = error;
      this.errorAlertEvent = true;
    },

    saveAddress() {
      //TODO check pincode validation on server same as agent app
      const addressPayload = AddressResponse.getAddressPayload(this.address);
      this.loading = true;
      DataSource.saveClientAddress(LoanScopeDataHolder.getClientId(),
        this.address[AddressResponse.ADDRESS_TYPE_ID], addressPayload)
        .then(clientAddressSaveRes => {
          if (clientAddressSaveRes.errorOccurred) {
            this.showError(clientAddressSaveRes.data);
          } else {
            this.saveAddressAndCityInfoIfNeeded();
          }
        })
    },

    saveAddressAndCityInfoIfNeeded() {
      const addressAndCityInfo = {};
      let needToStoreData = false;
      for (const [key, value] of Object.entries(this.addressTimeData)) {
        if (value) {
          addressAndCityInfo[key] = value;
          needToStoreData = true;
        }
      }
      if (needToStoreData) {
        this.loading = true;
        DataSource.getDataTableInfo(DataTables.PERSONAL_DETAILS, LoanScopeDataHolder.getClientId())
          .then(personalDetailsRes => {
            if (personalDetailsRes.errorOccurred) {
              this.showError(personalDetailsRes.data)
            } else {
              if (EzUtils.isNotEmpty(personalDetailsRes.data)) {
                DataSource.updateDataTableEntry(DataTables.PERSONAL_DETAILS,
                  LoanScopeDataHolder.getClientId(),
                  addressAndCityInfo
                )
                  .then(res => {
                    this.loading = false;
                    if (res.errorOccurred) {
                      this.showError(res.data)
                    } else {
                      this.completeCurrentTaskAndGetNextTask();
                    }
                  })
              } else {
                DataSource.addDataTableEntry(
                  DataTables.PERSONAL_DETAILS,
                  LoanScopeDataHolder.getClientId(),
                  addressAndCityInfo
                )
                  .then(res => {
                    this.loading = false;
                    if (res.errorOccurred) {
                      this.showError(res.data)
                    } else {
                      this.completeCurrentTaskAndGetNextTask();
                    }
                  })
              }
            }
          })
      } else {
        this.completeCurrentTaskAndGetNextTask();
      }
    },

    completeCurrentTaskAndGetNextTask() {
      this.loading = true;
      LoanTasksActivityNavigator.getNextTask(this.tasks)
        .then(res => {
          this.loading = false;
          if (res.errorOccurred) {
            this.showError(res.data);
          }
        });
    },

    filterState() {
      this.stateList = [];
      let states = [];
      this.stateProvinceIdOptions.forEach(code => {
        states.push(code.name);
      });
      states.sort();
      this.stateList = states;
    },

    fetchInitialData() {
      this.showRefreshItem = false;
      this.loading = true;

      LoanTasksUtility.getLoanStageConfigData(LoanScopeDataHolder.getLoanId(), "ADDRESS")
      .then(stageConfigDataRes => {
        if (!stageConfigDataRes.errorOccurred) {
          const addressStageConfigData = stageConfigDataRes.data;
          if(addressStageConfigData.properties){
            this.addressProofWillRequiredLater = addressStageConfigData.properties["address.proof.required"];
          }
        }
      });
      LoanTasksUtility.getLoanStageConfigData(LoanScopeDataHolder.getLoanId(), "KYC")
        .then(stageConfigDataRes => {
          if (stageConfigDataRes.errorOccurred) {
            this.showError(stageConfigDataRes.data);
            this.showRefreshItem = true;
          } else {
            const stageConfigData = stageConfigDataRes.data;
            this.kycStageDataConfig = stageConfigData;
            if (stageConfigData
              && stageConfigData.kycOSVDetailsDto
              && stageConfigData.kycOSVDetailsDto.allowedAddressProofs
            ) {
              this.allowedAddressProofsList = stageConfigData.kycOSVDetailsDto.allowedAddressProofs
            }
            DataSource.getAddressTemplates()
              .then(addressTemplateRes => {
                this.loading = false;
                if (addressTemplateRes.errorOccurred) {
                  this.showError(addressTemplateRes.data);
                  this.showRefreshItem = true;
                } else {
                  this.addressTypeId = DataTableUtils.getOptionId(
                    addressTemplateRes.data[AddressResponse.ADDRESS_TYPE_ID_OPTIONS],
                    "home"
                  );
                  this.countryId = DataTableUtils.getOptionId(
                    addressTemplateRes.data[AddressResponse.COUNTRY_ID_OPTIONS],
                    "India"
                  );
                  this.stateProvinceIdOptions = addressTemplateRes.data[AddressResponse.STATE_PROVINCE_ID_OPTIONS];
                  this.addressOwnerTypeIdOptions = addressTemplateRes.data[AddressResponse.ADDRESS_OWNERSHIP_TYPE_OPTIONS];
                  this.filterState();
                  this.populateAddressOwnershipList();
                  this.fetchLeadOrClientAddress();
                }
              })
          }
        });
    },

    fetchLeadOrClientAddress() {
      this.loading = true;
      if (EzUtils.isValidId(LoanScopeDataHolder.getLeadId())) {
        DataSource.getLeadDetails(LoanScopeDataHolder.getLeadId())
          .then(leadDetailsRes => {
            this.loading = false;
            if (leadDetailsRes.errorOccurred) {
              this.showError(leadDetailsRes.data);
              this.showRefreshItem = true;
            } else {
              const leadDetails = leadDetailsRes.data;
              const leadDetailsData = leadDetails && leadDetails.data
                ? EzUtils.convertToJSONObjectIfString(leadDetails.data)
                : {};
              if (leadDetailsData
                && leadDetailsData.addresses
                && leadDetailsData.addresses.length > 0
              ) {
                this.showUI = true;
                const addresses = leadDetailsData.addresses;
                let address = addresses[addresses.length - 1];
                addresses.forEach(addressInLead => {
                  if (addressInLead
                    && EzUtils.areEqualString("RESIDENCE", addressInLead.type, true)
                  ) {
                    address = addressInLead;
                  }
                });
                this.inputEntered(AddressResponse.STATE_PROVINCE_ID, -1);
                this.inputEntered(AddressResponse.ADDRESS_TYPE_ID, this.addressTypeId);
                this.inputEntered(AddressResponse.COUNTRY_ID, this.countryId);
                this.inputEntered(AddressResponse.STREET, address.street);
                this.inputEntered(AddressResponse.ADDRESS_LINE1, address.address_line_1);
                this.inputEntered(AddressResponse.ADDRESS_LINE2, address.address_line_2);
                this.inputEntered(AddressResponse.ADDRESS_LINE3, address.address_line_3);
                this.inputEntered(AddressResponse.CITY, address.city);
                this.postalEntered(address.pincode);
                this.selectAddressOwnership(address[AddressResponse.ADDRESS_OWNERSHIP_TYPE]);
              } else {
                this.fetchClientAddress();
              }
            }
          })
      } else {
        this.fetchClientAddress();
      }
    },

    fetchClientAddress() {
      this.loading = true;
      DataSource.getClientAddress(
        LoanScopeDataHolder.getClientId(),
        new Array(true),
        this.addressTypeId
      )
        .then(clientAddressRes => {
          this.loading = false;
          if (clientAddressRes.errorOccurred) {
            this.showError(clientAddressRes.data);
            this.showRefreshItem = true;
          } else {
            this.showUI = true;
            this.inputEntered(AddressResponse.STATE_PROVINCE_ID, -1);
            this.inputEntered(AddressResponse.ADDRESS_TYPE_ID, this.addressTypeId);
            this.inputEntered(AddressResponse.COUNTRY_ID, this.countryId);
            const addresses = clientAddressRes.data;
            if (EzUtils.isNotEmpty(addresses)) {
              const address = addresses[addresses.length - 1];
              this.inputEntered(AddressResponse.STREET, address[AddressResponse.STREET]);
              this.inputEntered(
                AddressResponse.ADDRESS_LINE1,
                address[AddressResponse.ADDRESS_LINE1]
              );
              this.inputEntered(
                AddressResponse.ADDRESS_LINE2,
                address[AddressResponse.ADDRESS_LINE2]
              );
              this.inputEntered(
                AddressResponse.ADDRESS_LINE3,
                address[AddressResponse.ADDRESS_LINE3]
              );
              this.inputEntered(AddressResponse.CITY, address[AddressResponse.CITY]);
              this.postalEntered(address[AddressResponse.POSTAL_CODE]);
              this.selectAddressOwnership(address[AddressResponse.ADDRESS_OWNERSHIP_TYPE]);
            }
          }
        })
    },

    populateAddressOwnershipList() {
      this.addressOwnershipList = [];
      let ownerships = [];
      if(this.addressOwnerTypeIdOptions){
        this.addressOwnerTypeIdOptions.forEach(ownership => {
          ownerships.push(ownership.name);
        });
        ownerships.sort();
        this.addressOwnershipList = ownerships;
      }
    },

    selectAddressOwnership(id){
      let name = DataTableUtils.getOptionName(this.addressOwnerTypeIdOptions, id);
      if(name){
        this.onOwnershipEntered(name);
      }
    }
    

  },

  created: function () {
    this.dynamicFields = DynamicFieldUtils.getRequiredDynamicFieldsData();
    this.fetchInitialData();
  },

  computed: {
    redirectActivity() {
      return Activities.LOAN_DETAILS;
    },

    tasks() {
      return [Activities.ADDRESS];
    },

    currentTaskName() {
      return LoanScopeDataHolder.getCurrentLoanTask()
        ? LoanScopeDataHolder.getCurrentLoanTask().name
        : "";
    },

    dropdownConfig() {
      return DefaultResourceConfig.DROP_DOWN;
    },

    addressHeading() {
      if(!this.addressProofWillRequiredLater){
        return "Please enter customer’s residence address."
      }else{
        const addressOwner = this.isAgent ? "customer's" : "your";
        return `Please enter ${addressOwner} residence address. Address has to match with any of the supporting Address Proof Documents - ${EzUtils.joinArray(
          ", ", this.readableAllowedAddressProofs)}.`
      }
    },

    addressDescription() {
      return "(Address Proof will be required later)";
    },

    isAgent() {
      return PrefManager.doesUserHasRole(RolesConstants.AGENT);
    },

    rupeeSign() {
      return RUPEE;
    },

    readableAllowedAddressProofs() {
      let allowedAddressProofs = [];
      const addressList = EzUtils.isNotEmpty(this.allowedAddressProofsList)
        ? this.allowedAddressProofsList
        : DEFAULT_ADDRESS_LIST;
      addressList && addressList.forEach(addressProof => {
        allowedAddressProofs.push(EzUtils.removeUnderscoreFromString(addressProof, ['ID']));
      });
      return allowedAddressProofs;
    },
    
    kycOsvDetailsConfig() {
      return this.kycStageDataConfig ? this.kycStageDataConfig.kycOSVDetailsDto : {};
    },

    okycDataConfig() {
      return this.kycStageDataConfig ? this.kycStageDataConfig.oKycDetails : {};
    },
  }
}
</script>
 
<style scoped src="../../assets/style/base.css"></style> 

-->
